import React from 'react';
import { PAGE_TITLES } from '../nav.js';

export default function Topbar({ page, user, onNavigate, onMenuClick }) {
  const roleLabel = user?.role === 'admin' ? 'Admin' : user?.role === 'teamleader' ? 'Team Leader' : 'Salesman';

  // Derive title from the shared nav config; fallback to capitalising the page key
  const pageTitle = PAGE_TITLES[page]
    ?? (page ? page.replace(/-/g, ' ').replace(/\b\w/g, c => c.toUpperCase()) : 'Meetel');

  return (
    <header className="topbar">
      <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
        {/* Hamburger — shown on mobile via CSS */}
        <button className="hamburger-btn" onClick={onMenuClick} aria-label="Open menu">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
            <line x1="3" y1="6" x2="21" y2="6" />
            <line x1="3" y1="12" x2="21" y2="12" />
            <line x1="3" y1="18" x2="21" y2="18" />
          </svg>
        </button>
        <div className="topbar-title">{pageTitle}</div>
      </div>

      <div className="topbar-right">
        <button className="notif-btn" onClick={() => onNavigate('alerts')}>
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9" />
            <path d="M13.73 21a2 2 0 0 1-3.46 0" />
          </svg>
          <span className="notif-badge" />
        </button>
        <div className="t-avatar" onClick={() => onNavigate('settings')} title="Settings">
          {user?.name?.charAt(0) || 'A'}
        </div>
        {/* Hide name on small screens */}
        <div className="hide-mobile">
          <div style={{ fontSize: 13, fontWeight: 700, lineHeight: 1 }}>{user?.name || 'Admin'}</div>
          <div style={{ fontSize: 10, color: 'var(--text-muted)', lineHeight: 1.2 }}>{roleLabel}</div>
        </div>
      </div>
    </header>
  );
}
